import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../lib/utils';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'outline';
  size?: 'lg' | 'xl';
}
export function Button({
  children,
  className,
  variant = 'primary',
  size = 'lg',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gold-500';
  const variants = {
    primary: 'bg-gold-500 text-navy-950 hover:bg-gold-400 shadow-lg shadow-gold-500/20',
    outline: 'border-2 border-gold-500 text-gold-500 hover:bg-gold-500/10'
  };
  const sizes = {
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl sm:text-2xl'
  };
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={cn(baseStyles, variants[variant], sizes[size], className)} {...props} data-id="element-40">
      {children}
    </motion.button>;
}